import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconArrow2Left = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 23.906 13.91'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M22.901,7.942 L3.388,7.942 L7.665,12.209 C8.055,12.597 8.055,13.227 7.665,13.615 C7.471,13.809 7.216,13.906 6.961,13.906 C6.706,13.906 6.451,13.809 6.257,13.615 L0.279,7.651 C0.279,7.651 0.279,7.650 0.278,7.650 C0.187,7.559 0.114,7.450 0.064,7.329 C-0.037,7.085 -0.037,6.811 0.064,6.568 C0.114,6.447 0.187,6.338 0.278,6.247 C0.279,6.246 0.279,6.246 0.279,6.246 L6.257,0.282 C6.646,-0.106 7.276,-0.106 7.665,0.282 C8.055,0.670 8.055,1.300 7.665,1.688 L3.388,5.955 L22.901,5.955 C23.451,5.955 23.897,6.399 23.897,6.948 C23.897,7.497 23.451,7.942 22.901,7.942 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconArrow2Left.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
